<div
  class="mat-typography information-border"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  fxLayoutGap="1rem"
>
  <div tcColor="information" class="header color margin_l_sm margin_t_sm">
    <mat-icon class="margin_r_sm">search</mat-icon>
    Lookup Tax Code
  </div>

  <div class="margin_h_md">
    <form [formGroup]="form">
      <mat-form-field style="width: 100%">
        <mat-label>Tax Code</mat-label>
        <mat-select formControlName="parent">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let option of parentOptions$ | async" [value]="option.ticId">
            {{option.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="(childOptions$ | async).length" style="width: 100%">
        <mat-label>Sub Category</mat-label>
        <mat-select formControlName="child">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let option of childOptions$ | async " [value]="option.ticId">
            {{option.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="(grandchildOptions$ | async).length" style="width: 100%">
        <mat-label>Sub Category</mat-label>
        <mat-select formControlName="grandchild">
          <mat-option>None</mat-option>
          <mat-option
            *ngFor="let grandchild of grandchildOptions$ | async "
            [value]="grandchild.ticId"
          >
            {{grandchild.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div *ngIf="selected$ | async as selected" class="documentation margin_t_sm">
      <div [innerHTML]="selected.documentation | safe:'html'"></div>
    </div>
  </div>

  <div class="margin_v_sm margin_r_sm" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="1rem">
    <button
      mat-button
      data-cy="selectTicButton"
      tcColor="information"
      [disabled]="!selected$.value"
      (click)="confirm()"
    >
      SELECT
    </button>
    <button data-cy="cancelTicButton" mat-button (click)="cancel()">CANCEL</button>
  </div>
</div>
